import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IInitialSliceState } from "../../common/types/commonTypes";
import { deleteOrgUrl } from "../../config";
import { IDeleteGroupPayload } from "../../common/types/groupTypes";
import { Status } from "../../common/constants";
import api from '../../api';

const DELETE_GROUP: string = "deleteGroup"

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null
};

interface IDeleteGroupModalResponse {
  message: string
}

export const deleteModal = createAsyncThunk(DELETE_GROUP, async (payload: IDeleteGroupPayload, { rejectWithValue }) => {
    try {
      const response = await api.delete<IDeleteGroupModalResponse>(deleteOrgUrl, { data: payload });
      const deleteModalResponse: IDeleteGroupModalResponse = response.data;
      return deleteModalResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const deleteModalSlice = createSlice({
  name: DELETE_GROUP,
  initialState,
  reducers: {
    clearDeleteGroup: (state) => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteModal.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(deleteModal.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(deleteModal.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export const { clearDeleteGroup } = deleteModalSlice.actions;

export default deleteModalSlice.reducer;